/** @jsxImportSource @emotion/react */
import React, { useCallback, useState } from 'react';
import { jsx, css } from '@emotion/react';
import { FormattedMessage } from 'components/i18n';
import Modal from './Modal';
import { ModalProps } from './types';
import { ModalBody, ModalFooter, ModalHeader, ModalTitle } from "@atlaskit/modal-dialog";
import Button, { LoadingButton } from "@atlaskit/button";

type Props = ModalProps & {
  onConfirm?: () => Promise<any>;
}

const DeleteModal: React.FC<Props> = ({onClose, title, content, onConfirm}) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = useCallback(()=> {
    (async () => {
      if (onConfirm) {
        setIsDeleting(true);
        try {
          await onConfirm();
          onClose();
        } finally {
          setIsDeleting(false);
        }
      }else {
        onClose();
      }
    })();
  },[onClose, onConfirm]);

  return (
      <Modal
        onClose={onClose}
        autoFocus={false}
        width="small"
        shouldScrollInViewport={false}
      >
        <ModalHeader><ModalTitle appearance="danger">
          {title || <FormattedMessage
            id='components.modals.delete.defaultTitle'
            defaultMessage='Delete this?'
          />}
        </ModalTitle></ModalHeader>
        <ModalBody>
          {content || <FormattedMessage
            id='components.modals.delete.defaultContent'
            defaultMessage={`It will be deleted forever!`}
          />
          }
        </ModalBody>
        <ModalFooter>
          <Button appearance="subtle" onClick={onClose}>
            <FormattedMessage id='components.modals.delete.cancel' defaultMessage='Cancel'/>
          </Button>
          <LoadingButton appearance="danger" type="submit" onClick={handleDelete} isLoading={isDeleting}>
            <FormattedMessage id='components.modals.delete.delete' defaultMessage='Delete' />
          </LoadingButton>
        </ModalFooter>

  </Modal>
  );
};

export default DeleteModal;
